export enum Language {
  ENGLISH = 'EN',
  CROATIAN = 'HR',
}

export const LANGUAGE_LABEL_MAP = {
  [Language.ENGLISH]: 'English',
  [Language.CROATIAN]: 'Croatian',
} as const;

export const LANGUAGE_ARRAY = Object.values(Language);

export const supportedLocales = LANGUAGE_ARRAY.map(code => code.toLowerCase());

export type Locale = 'en' | 'hr';
